export default(handlers) => {
  const allHandlers = {
    ...handlers
  }

  return (state, action) => {
    const handler = allHandlers[action.type];
    return handler ? handler(state, action) : state;
  }
}